module.exports = __webpack_public_path__ + "img/hr-tree-01-a-trunk.b5d65f0c.png";